import UserActions from 'actions/UserActions';
import API from './API';

const UserSource = {
  login: {
    remote(state) {
      let param = {
        method: 'POST',
        body: `email=${state.email}&password=${state.password}`,
        headers: API.urlHeader
      };
      return fetch(API.postLogin, param).then(res=>res.json());
    },
    shouldFetch() {
      return true;
    },
    success: UserActions.loginSuccess,
    error: UserActions.loginFailed
  },
  regist: {
    remote(state) {
      let param = {
        method: 'POST',
        headers: API.urlHeader,
        body: `email=${state.email}&password=${state.password}&value=${state.captcha}&_key=${state.captchaKey}`
      };
      return fetch(API.postRegister, param).then(res=>res.json());
    },
    shouldFetch() {
      return true;
    },
    success: UserActions.registSuccess,
    error: UserActions.loginFailed
  },
  forget: {
    remote(state) {
      let param = {
        method: 'POST',
        headers: API.urlHeader,
        body: `email=${state.email}&value=${state.captcha}&_key=${state.captchaKey}`
      };
      return fetch(API.postForget, param).then(res=>res.json());
    },
    shouldFetch() {
      return true;
    },
    success: UserActions.forgetSuccess,
    error: UserActions.loginFailed
  },
  fetchUser: {
    remote(state) {
      if(state.user_id) {
        return fetch(API.getUserInfo.replace(':id', state.user_id)).then(res=>res.json());
      } else {  // 获取当前登录用户
        return fetch(API.getUser).then(res=>res.json());
      }
    },
    shouldFetch() {
      return true;
    },
    success: UserActions.fetchUserSuccess,
    error: UserActions.fetchFailed
  },
  fetchAgent: {
    remote(state) {
      if(state.user_id) {
        return fetch(API.getOtherAgentInfo.replace(':id', state.user_id)).then(res=>res.json());
      } else {  // 获取当前登录用户
        return fetch(API.getAgentInfo).then(res=>res.json());
      }
    },
    shouldFetch() {
      return true;
    },
    success: UserActions.fetchAgentSuccess,
    error: UserActions.fetchFailed
  },
  postAgent: {
    remote(state) {
      let param = {
          method: 'POST',
          body: JSON.stringify(state.postAgent),
          headers: API.jsonHeader
      };
      return fetch(API.postAgent, param).then(res=>res.json());
    },
    shouldFetch(state) {
      return true;
    },
    success: UserActions.postAgentSuccess,
    error: UserActions.fetchFailed
  },
  fetchAgentArticles: {
    remote(state) {
      return fetch(`${API.getAgentArticles.replace(':id',state.user_id)}&first=${state.first}&maxCount=60`).then(res=>res.json());
    },
    shouldFetch() {
      return true;
    },
    success: UserActions.fetchAgentArticlesSuccess,
    error: UserActions.fetchFailed
  },
  fetchCaptcha: {
    remote() {
      return fetch(API.getCaptcha).then(res=>{
        let key = res.headers.get('_key');
        return {key: key, blob: res.blob()};
      });
    },
    shouldFetch() {
      return true;
    },
    success: UserActions.fetchCaptchaSuccess,
    error: UserActions.fetchFailed
  },
  postUserInfo: {
    remote(state) {
      let params = {
        method: 'POST',
        headers: API.jsonHeader,
        body: JSON.stringify(state.userInfo)
      };
      return fetch(API.postUserUpdate, params).then(res=>res.json());
    },
    shouldFetch() {
      return true;
    },
    success: UserActions.postUserSuccess,
    error: UserActions.fetchFailed
  },
  fetchPaidMedias: {
    remote(state) {
      if(state.user_id) {
        return fetch(`${API.getPaidMediaByUser.replace(':id', state.user_id)}&first=${state.first}&maxCount=${state.maxCount}`).then(res=>res.json());
      } else {  // 获取当前登录用户
        return fetch(`${API.getUserMediaPaid}&first=${state.first}&maxCount=${state.maxCount}`).then(res=>res.json());
      }
    },
    shouldFetch() {
      return true;
    },
    success: UserActions.fetchPaidMediasSuccess,
    error: UserActions.fetchFailed
  },
  fetchPublishMedias: {
    remote(state) {
      if(state.user_id) {
        return fetch(`${API.getPublishMediaByUser.replace(':id', state.user_id)}&first=${state.first}&maxCount=${state.maxCount}`).then(res=>res.json());
      } else {  // 获取当前登录用户
        return fetch(`${API.getUserMedia}&first=${state.first}&maxCount=${state.maxCount}`).then(res=>res.json());
      }
    },
    shouldFetch() {
      return true;
    },
    success: UserActions.fetchPublishMediasSuccess,
    error: UserActions.fetchFailed
  },
  fetchCollectMedias: {
    remote(state) {
      if(state.user_id) {
        return fetch(`${API.getCollectMediaByUser.replace(':id', state.user_id)}&first=${state.first}&maxCount=${state.maxCount}`).then(res=>res.json());
      } else {  // 获取当前登录用户
        return fetch(`${API.getUserMediaCollect}&first=${state.first}&maxCount=${state.maxCount}`).then(res=>res.json());
      }
    },
    shouldFetch() {
      return true;
    },
    success: UserActions.fetchCollectMediasSuccess,
    error: UserActions.fetchFailed
  },
  fetchPublishAlbums: {
    remote(state) {
      if(state.user_id) {
        return fetch(`${API.getPublishAlbumByUser.replace(':id', state.user_id)}&first=${state.first}&maxCount=${state.maxCount}`).then(res=>res.json());
      } else {  // 获取当前登录用户
        return fetch(`${API.getUserAlbum}&first=${state.first}&maxCount=${state.maxCount}`).then(res=>res.json());
      }
    },
    shouldFetch() {
      return true;
    },
    success: UserActions.fetchPublishAlbumsSuccess,
    error: UserActions.fetchFailed
  },
  fetchCollectAlbums: {
    remote(state) {
      if(state.user_id) {
        return fetch(`${API.getCollectAlbumByUser.replace(':id', state.user_id)}&first=${state.first}&maxCount=${state.maxCount}`).then(res=>res.json());
      } else {  // 获取当前登录用户
        return fetch(`${API.getUserAlbumCollect}&first=${state.first}&maxCount=${state.maxCount}`).then(res=>res.json());
      }
    },
    shouldFetch() {
      return true;
    },
    success: UserActions.fetchCollectAlbumsSuccess,
    error: UserActions.fetchFailed
  },
  fetchFollowing: {
    remote(state) {
      if(state.user_id) {
        return fetch(`${API.getFollowingByUser.replace(':id', state.user_id)}&first=${state.first}&maxCount=${state.maxCount}`).then(res=>res.json());
      } else {  // 获取当前登录用户
        return fetch(`${API.getUserFollowing}&first=${state.first}&maxCount=${state.maxCount}`).then(res=>res.json());
      }
    },
    shouldFetch() {
      return true;
    },
    success: UserActions.fetchFollowingSuccess,
    error: UserActions.fetchFailed
  },
  fetchWants: {
    remote(state) {
      if(state.user_id) {
        // return fetch(`${API.getWantsByUser.replace(':id', state.user_id)}&first=${state.first}&maxCount=${state.maxCount}`).then(res=>res.json());
      } else {  // 获取当前登录用户
        return fetch(`${API.getUserWantList}&first=${state.first}&maxCount=${state.maxCount}`).then(res=>res.json());
      }
    },
    shouldFetch() {
      return true;
    },
    success: UserActions.fetchWantsSuccess,
    error: UserActions.fetchFailed
  },
  fetchLinks: {
    remote(state) {
      if(state.user_id) {
        // return fetch(`${API.getLinksByUser.replace(':id', state.user_id)}&first=${state.first}&maxCount=${state.maxCount}`).then(res=>res.json());
      } else {  // 获取当前登录用户
        return fetch(`${API.getUserLinkList}&first=${state.first}&maxCount=${state.maxCount}`).then(res=>res.json());
      }
    },
    shouldFetch() {
      return true;
    },
    success: UserActions.fetchLinksSuccess,
    error: UserActions.fetchFailed
  },
  fetchFollowed: {
    remote(state) {
      if(state.user_id) {
        return fetch(`${API.getFollowerByUser.replace(':id', state.user_id)}&first=${state.first}&maxCount=${state.maxCount}`).then(res=>res.json());
      } else {  // 获取当前登录用户
        return fetch(`${API.getUserFollower}&first=${state.first}&maxCount=${state.maxCount}`).then(res=>res.json());
      }
    },
    shouldFetch() {
      return true;
    },
    success: UserActions.fetchFollowedSuccess,
    error: UserActions.fetchFailed
  },
  postFollow: {
    remote(state) {
      let params = {
        method: 'POST',
        headers: API.urlHeader,
        body: `accessToken=${state.accessToken}`
      };
      return fetch(API.postUserFollow.replace(':id', state.user._id), params).then(res=>res.json());
    },
    shouldFetch() {
      return true;
    },
    success: UserActions.postFollowSuccess,
    error: UserActions.fetchFailed
  },
  postUnfollow: {
    remote(state) {
      let params = {
        method: 'POST',
        headers: API.urlHeader,
        body: `accessToken=${state.accessToken}`
      };
      return fetch(API.postUserUnfollow.replace(':id', state.user._id), params).then(res=>res.json());
    },
    shouldFetch() {
      return true;
    },
    success: UserActions.postUnfollowSuccess,
    error: UserActions.fetchFailed
  }
};

export default UserSource;



// WEBPACK FOOTER //
// ./src/sources/UserSource.js